import { render } from "./Firmware.vue?vue&type=template&id=099e60ba"
const script = {}
script.render = render

export default script